import styled from 'styled-components';
import { colors } from '../../assets/variables';

const Card = styled.div``;

const RoomTypeText = styled.p`
  padding-bottom: 16px;
  text-align: right;

  color: ${colors.baseDark};
  span {
    text-transform: capitalize;
    font-weight: 600;
    color: ${colors.primary};
  }
`;
const Success = styled.div`
  border: 1px solid #d6e4f2;
  border-radius: 8px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
const TopBtnWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .back-button {
    min-width: 100px;
    background: white;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
  }
`;
export default { Card, RoomTypeText, Success, TopBtnWrap };
